import { provideTransloco } from '@jsverse/transloco';
import { provideTranslocoLocale } from '@jsverse/transloco-locale';
import { TranslocoHttpLoader } from '../services/transloco-loader.service';
import { LocalizationConfig } from '../models/localization.models';
import { TRANSLATION_BASE_URL } from '../tokens/base-url.token';

/**
 * Provides localization configuration for Transloco.
 *
 * This function sets up the Transloco loader with the necessary configurations,
 * including the available languages, default language, and production mode.
 * It also injects the `TRANSLATION_BASE_URL` to the loader, allowing the
 * translation base URL to be dynamically set based on the provided configuration.
 *
 * @param config LocalizationConfig object that contains configuration like baseUrl.
 * @returns An array of providers, including the Transloco configuration and the base URL for translations.
 */
export const provideLocalization = (config: LocalizationConfig) => {
  return [
    // Provide Transloco configuration for managing translations
    provideTransloco({
      config,
      loader: TranslocoHttpLoader, // Use custom loader for fetching translations
    }),

    // Provide the base URL for the translation files, which is injected into the Transloco loader
    {
      provide: TRANSLATION_BASE_URL, // Injection token for the translation base URL
      useValue: config.baseUrl, // Dynamically set the base URL based on the provided config
    },

    provideTranslocoLocale(config?.localeConfig),
  ];
};
